import {IS_FEDERATE_MODULE} from "./navigation";

export const TOKEN_KEY = 'token';
export const HIDE_CUSTOMER_HEADER_KEY = 'hide_end_customer_header';
export const NEW_ORIGIN_KEY = 'new_origin';
export const CUSTOMER_ID_KEY = 'customer_id';
export const USER_KEY = 'user';
export const SHARED_SETTINGS_KEY = 'shared_settings';

export const STORAGE_TYPE = {
  SESSION: 'SESSION',
  LOCAL: 'LOCAL'
}

export const getStorageByType = (type) => {
  if (type == STORAGE_TYPE.LOCAL) {
    return localStorage;
  }
  return sessionStorage
}

const getStorageKey = (key) => IS_FEDERATE_MODULE ? `bca-investment-app-${key}` : key;

export const setInStorage = (key, value, type=STORAGE_TYPE.LOCAL) => {
    try {
      const serializedValue = JSON.stringify(value);
      let storage = getStorageByType(type);
      storage.setItem(getStorageKey(key), serializedValue);
    } catch (err) {
      // TODO: log error?
    }
  };

export const getFromStorage = (key, type=STORAGE_TYPE.LOCAL) => {
  try {
    let storage = getStorageByType(type);
    const value = storage.getItem(getStorageKey(key));
    if (value === null) {
      return undefined;
    }
    return JSON.parse(value);
  } catch (err) {
    return undefined;
  }
};

export const removeFromStorage = (key, type=STORAGE_TYPE.LOCAL) => {
  try {
    let storage = getStorageByType(type);
    storage.removeItem(getStorageKey(key));
  } catch (err) {
    console.error(err);
  }
};
